import styled from "styled-components";

const StyledCardImage = styled.img<{ notFixed?: boolean }>`
  width: 100%;
  height: ${({ notFixed }) => (notFixed ? "auto" : "200px")};
  object-fit: cover;
`;

export default StyledCardImage;
